export const buildVideoStylesheet = (builder, device, cta, element) => {
    let options = { ...element.options };

    let boxShadow;

    if (options["box-shadow"] == "soft") {
      boxShadow = "0 5px 15px 0 rgb(179 179 179 / 78%)";
    }

    if (options["box-shadow"] == "hard") {
      boxShadow = "-5px 5px 0 0 rgb(0 0 0 / 10%)";
    }

    if (options["box-shadow"] == "custom") {
      boxShadow = "";
      boxShadow +=
        (element.options["box-shadow-horizontal-distance"]
          ? `${element.options["box-shadow-horizontal-distance"]}px`
          : "0px") + " ";

      boxShadow +=
        (element.options["box-shadow-vertical-distance"]
          ? `${element.options["box-shadow-vertical-distance"]}px`
          : "0px") + " ";

      boxShadow +=
        (element.options["box-shadow-blur-radius"]
          ? `${element.options["box-shadow-blur-radius"]}px`
          : "0px") + " ";

      boxShadow +=
        (element.options["box-shadow-spread-radius"]
          ? `${element.options["box-shadow-spread-radius"]}px`
          : "0px") + " ";

      boxShadow +=
        (element.options["box-shadow-color"]
          ? element.options["box-shadow-color"]
          : "rgba(0,0,0, 0.35)") + " ";
    }

    // prettier-ignore
    const desktopStyles =
`#cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-video-outer {
  ${boxShadow ? 'box-shadow: ' + boxShadow + ' !important;' : ''}
  ${options["video-embed-width"] == 'custom' && options["video-embed-width-value"] ? 'max-width: ' + options["video-embed-width-value"] + 'px !important;' : ''}
}

#cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-video {
  max-width: 100%;
  min-height: 20px;
  ${options["video-embed-height-value"] ? `height: ${options["video-embed-height-value"]}px !important;` : 'padding-top: 56.25%;'}
}

#cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-html-placeholder {
  width: 100%;
  ${options["video-embed-height-value"] ? `height: ${options["video-embed-height-value"]}px !important;` : ''}
}
`;

    // prettier-ignore
    const mobileStyles =
`/* mobile styles */
#cta_${cta.id} .cf-element[data-element-id="${element.id}"] {
}

#cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-video,
#cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-html-placeholder {
  ${options["video-embed-height-value-mobile"] ? `height: ${options["video-embed-height-value-mobile"]}px !important;` : ''}
}
`;

    if (builder !== true) {
      return desktopStyles + "@media (max-width: 599px) {" + mobileStyles + "}";
    } else {
      if (device == "desktop") {
        return desktopStyles;
      } else {
        return desktopStyles + mobileStyles;
      }
    }
};
